/**
 * Pinned Form Height Calculator
 * Updates CSS variable for pinned form height
 */
export default function PinnedForm() {
    function updatePinnedHeight() {
        const pinned = document.querySelector('.form-layout--pinned--fixed') || document.querySelector('.form-layout--pinned');
        const root = document.documentElement;
        const height = pinned ? pinned.offsetHeight : 0;
        root.style.setProperty('--pinned-form-height', `${height}px`);
    
        if (pinned) {
            document.body.classList.add('has-pinned-form');
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updatePinnedHeight);
    } else {
        updatePinnedHeight();
    }

    window.addEventListener('resize', updatePinnedHeight);
}
